/**
 * statAnalysis 统计分析
 */

const App = () => import('@/module/index/layout/App.vue')
const platformap = () => import('@/module/index/pages/statAnalysis/platformap.vue')
const disputesubject = () => import('@/module/index/pages/statAnalysis/disputesubject.vue')
const userstatistics = () => import('@/module/index/pages/statAnalysis/userstatistics.vue')

export default {
  path: '/statAnalysis',
  component: App,
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/statAnalysis/platformap',
    component: platformap
  }, {
    path: '/statAnalysis/disputesubject',
    component: disputesubject
  }, {
    path: '/statAnalysis/userstatistics',
    component: userstatistics
  }]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/statAnalysis.js